const styles = (theme) => ({
  root: {
    cursor: "none !important",
    padding: "190px 270px 0px 270px",
    display: "flex",
    marginTop: "-1px",
    position: "relative",
    maxWidth: "1700px",
    margin: "auto",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1350)]: {
      padding: "0 200px 200px 200px",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
      padding: "0 100px 200px 100px",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 850)]: {
      padding: "0 1rem 80px 1rem",
      marginTop: "-30px",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 600)]: {
      padding: "0 .5rem 80px .5rem",
    },
  },
  h1: {
    fontFamily: "Montserrat",
    fontWeight: 700,
    fontSize: "60px",
    lineHeight: "75px",
    letterSpacing: "0.01em",
    margin: 0,
    color: "black",
    textAlign: "center",
    marginBottom: "30px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 850)]: {
      fontSize: "2rem",
      lineHeight: "38.5px",
      marginBottom: "20px",
    },
  },
  p: {
    cursor: "none !important",
    color: "black",
    fontFamily: "Aktiv Grotesk",
    display: "table",
    fontWeight: "400",
	textAlign: "center",
    fontSize: "1rem",
    margin: 0,
	marginBottom: "50px",
    lineHeight: "22.5px",
    letterSpacing: "0.01em",
    maxWidth: "74ch",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
      padding: "0 1rem",
    },
  },
  iframeWrap: {
    position: "relative",
    zIndex: 3,
    paddingBottom: "75%",
    height: "0",
    boxShadow: "5px 5px 30px rgba(0, 0, 0, 0.2)",
    width: "100%",
    overflow: "hidden",
  },
	iframe: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
	},
	video: {
		zIndex: 0,
		objectFit: "cover",
		position: "absolute",
		left: 0,
		top: 0,
		width: "100%",
		height: "100%",
		display: "block",
		pointerEvents: "none"
	},
});

export default styles;
